import { Skeleton } from '@/components/ui/skeleton'

const DashboardStatsSkeleton = () => {
  return (
    <div className='w-full grid grid-cols-1 md:grid-cols-3 gap-5'>
      {/* Total Restaurants Card */}
      <div className='bg-white rounded-[1.15rem] p-5 min-h-[10rem] flex flex-col justify-between'>
        <div className='flex justify-between'>
          <Skeleton className='h-6 w-40' />
          <Skeleton className='h-10 w-10 rounded-full' />
        </div>
        <div className='space-y-2'>
          <Skeleton className='h-4 w-32' />
          <Skeleton className='h-8 w-16' />
          <Skeleton className='h-4 w-28' />
        </div>
      </div>

      {/* Top City Card */}
      <div className='bg-white rounded-[1.15rem] p-5 min-h-[10rem] flex flex-col justify-between'>
        <div className='flex justify-between'>
          <Skeleton className='h-6 w-24' />
          <Skeleton className='h-10 w-10 rounded-full' />
        </div>
        <div className='space-y-2'>
          <Skeleton className='h-4 w-32' />
          <Skeleton className='h-8 w-20' />
          <Skeleton className='h-4 w-36' />
        </div>
      </div>
      {/* Top City Card */}
      <div className='bg-white rounded-[1.15rem] p-5 min-h-[10rem] flex flex-col justify-between'>
        <div className='flex justify-between'>
          <Skeleton className='h-6 w-24' />
          <Skeleton className='h-10 w-10 rounded-full' />
        </div>
        <div className='space-y-2'>
          <Skeleton className='h-4 w-32' />
          <Skeleton className='h-8 w-20' />
          <Skeleton className='h-4 w-36' />
        </div>
      </div>
    </div>
  )
}

export default DashboardStatsSkeleton
